import { toast } from '@dd3tech/wiggui/Toast'

interface IProps {
  address: string
  copyAddress?: boolean
  textClassName?: string
  className?: string
}
export const Address = ({
  address = '',
  copyAddress = true,
  textClassName = 'text-xs font-normal text-secondary',
  className = 'w-fit'
}: IProps) => {
  const handleClick = () => {
    navigator.clipboard.writeText(address)
    toast({
      type: 'success',
      title: 'Dirección copiada'
    })
  }
  return copyAddress ? (
    <button type="button" onClick={handleClick} className={className}>
      <p className={textClassName}>{address}</p>
    </button>
  ) : (
    <p>{address} </p>
  )
}
